import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${(props) => props.theme.spacing.md};
  height: 100%;
  padding: ${(props) => props.theme.spacing.lg};
  text-align: center;
  background: ${(props) => props.theme.colors.errorLight};
  border-radius: ${(props) => props.theme.borderRadius.base};
`;

export const Message = styled.p`
  margin: 0;
  font-size: ${(props) => props.theme.fontSize.base};
  color: ${(props) => props.theme.colors.errorDark};
  line-height: 1.4;
`;
